import { Group, Paper, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { UserDocumentSummary } from '../model/UserDocumentTypes';

interface UserDocumentSummaryStripProps {
  summary: UserDocumentSummary | undefined;
}

function SummaryStat({ label, value }: { label: string; value: number | string }) {
  return (
    <Paper
      role="group"
      aria-label={label}
      p="xs"
      flex={1}
      miw="140px"
    >
      <Stack
        gap={2}
        h="100%"
        justify="flex-end"
        align="center"
      >
        <Text
          size="xs"
          c="dimmed"
          ta="center"
        >
          {label}
        </Text>
        <Text size="lg">{value}</Text>
      </Stack>
    </Paper>
  );
}

export function UserDocumentSummaryStrip({ summary }: UserDocumentSummaryStripProps) {
  const { t } = useTranslation();

  if (summary == null) {
    return null;
  }

  return (
    <Group
      gap="xs"
      align="stretch"
    >
      <SummaryStat
        label={t('userDocuments.summary.users')}
        value={summary.users}
      />
      <SummaryStat
        label={t('userDocuments.summary.completeUsers')}
        value={`${summary.completeUsers} / ${summary.users}`}
      />
      {summary.perKind.map(entry => (
        <SummaryStat
          key={entry.kind}
          label={t(`userDocuments.kindEnum.${entry.kind}`)}
          value={entry.uploaded}
        />
      ))}
    </Group>
  );
}
